<template>
  <div class="box-for overflow">
    <div class="col-md-12 col-xs-12 login-blocks">
      <h2>{{ $t('labels.checklist') }}:</h2>
      <div class="row">
        <div class="col-xs-12" v-if="!isRestrictedAccess">
          <span :class="isSizeSet ? 'text-success' : 'text-danger'">
            <i :class="isSizeSet ? 'fa fa-check' : 'fa fa-close'"></i> {{ $t("checklist.size_set") }}
          </span>
        </div>
        <div class="col-xs-12" v-if="!isRestrictedAccess">
          <span :class="isBoothTypeSet ? 'text-success' : 'text-danger'">
            <i :class="isBoothTypeSet ? 'fa fa-check' : 'fa fa-close'"></i> {{ $t("checklist.booth_typ_set") }}
          </span>
        </div>
        <div class="col-xs-12">
          <span :class="checklist.minimum_checkout ? 'text-success' : 'text-danger'">
            <i :class="checklist.minimum_checkout ? 'fa fa-check' : 'fa fa-close'"></i> {{ $t("checklist.minimum_checkout") }}
          </span>
        </div>
        <div class="col-xs-12">
          <span :class="isRequiredInfoSet ? 'text-success' : 'text-danger'">
            <i :class="isRequiredInfoSet ? 'fa fa-check' : 'fa fa-close'"></i> {{ $t("checklist.data_set") }}
          </span>
        </div>
        <div class="col-xs-12" v-if="vatRequired">
          <span :class="hasCorrectVatId ? 'text-success' : 'text-danger'">
            <i :class="hasCorrectVatId ? 'fa fa-check' : 'fa fa-close'"></i> {{ hasCorrectVatId ? $t("checklist.vat_set") : $t("checklist.vat_not_set") }}
          </span>
        </div>
        <div class="col-xs-12">
          <span :class="isAddressSet ? 'text-success' : 'text-danger'">
            <i :class="isAddressSet ? 'fa fa-check' : 'fa fa-close'"></i> {{ $t("checklist.address_set") }}
          </span>
        </div>
        <div class="col-xs-12" v-if="isRegistration">
          <span :class="passwordsMatch ? 'text-success' : 'text-danger'">
            <i :class="passwordsMatch ? 'fa fa-check' : 'fa fa-close'"></i> {{ $t("checklist.passwords") }}
          </span>
        </div>
        <div class="col-xs-12" v-if="isHallNameRequired && isBoothNumberRequired">
          <span :class="isAdditionalInfoSet ? 'text-success' : 'text-danger'">
            <i :class="isAdditionalInfoSet ? 'fa fa-check' : 'fa fa-close'"></i> {{ $t("checklist.company_set") }}
          </span>
        </div>
        <div class="col-xs-12" v-if="isHallNameRequired && !isBoothNumberRequired">
          <span :class="isAdditionalInfoSet ? 'text-success' : 'text-danger'">
            <i :class="isAdditionalInfoSet ? 'fa fa-check' : 'fa fa-close'"></i> {{ $t("checklist.hall_name_set") }}
          </span>
        </div>
        <div class="col-xs-12" v-if="!isHallNameRequired && isBoothNumberRequired">
          <span :class="isAdditionalInfoSet ? 'text-success' : 'text-danger'">
            <i :class="isAdditionalInfoSet ? 'fa fa-check' : 'fa fa-close'"></i> {{ $t("checklist.booth_number_set") }}
          </span>
        </div>
        <div class="col-xs-12" v-if="hasBillAddress">
          <span :class="isPaymentAddressSet ? 'text-success' : 'text-danger'">
            <i :class="isPaymentAddressSet ? 'fa fa-check' : 'fa fa-close'"></i> {{
            $t("checklist.payment_address_set") }}
          </span>
        </div>
        <div class="col-xs-12" v-if="mandatoryRefinementCount > 0">
          <span :class="isBoothLabelSet ? 'text-success' : 'text-danger'">
            <i :class="isBoothLabelSet ? 'fa fa-check' : 'fa fa-close'"></i> {{ $t("checklist.booth_label") }}
          </span>
        </div>
        <div class="col-xs-12" v-if="isOrderNumberRequired">
          <span :class="isOrderNumberSet ? 'text-success' : 'text-danger'">
            <i :class="isOrderNumberSet ? 'fa fa-check' : 'fa fa-close'"></i> {{ $t("checklist.order_number") }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'

const store = useMainStore()

// props
const props = defineProps({
  exhibition: {
    type: Object,
    required: true
  },
  isRestrictedAccess: {
    type: Boolean,
    default: false
  },
  isSizeSet: {
    type: Boolean,
    default: false
  },
  isBoothTypeSet: {
    type: Boolean,
    default: false
  },
  isRequiredInfoSet: {
    type: Boolean,
    default: false
  },
  vatRequired: {
    type: Boolean,
    default: false
  },
  hasCorrectVatId: {
    type: Boolean,
    default: false
  },
  isAddressSet: {
    type: Boolean,
    default: false
  },
  isRegistration: {
    type: Boolean,
    default: false
  },
  passwordsMatch: {
    type: Boolean,
    default: false
  },
  isHallNameRequired: {
    type: Boolean,
    default: false
  },
  isBoothNumberRequired: {
    type: Boolean,
    default: false
  },
  isAdditionalInfoSet: {
    type: Boolean,
    default: false
  },
  hasBillAddress: {
    type: Boolean,
    default: false
  },
  isPaymentAddressSet: {
    type: Boolean,
    default: false
  },
  isBoothLabelSet: {
    type: Boolean,
    default: false
  },
  isOrderNumberRequired: {
    type: Boolean,
    default: false
  },
  isOrderNumberSet: {
    type: Boolean,
    default: false
  },
})

// computed props
const checklist = computed(() => store.checklist)
const basket = computed(() => store.settings.basket)

const mandatoryRefinementCount = computed(() => {

  return basket.value.selectedBooth ? basket.value.selectedBooth.refinements.reduce((t, refinement) => {
    if (refinement.mandatory && refinement.booth_type === basket.value.boothType.type) {
      t++
    }
    return t
  }, 0) : 1
})
</script>